import React from 'react';
import { WorkOff } from '@material-ui/icons';
import { IconButton, Tooltip } from '@material-ui/core';

interface Props {
  open: () => void;
  show: boolean;
}

export const RemoveFromShipmentButton = ({ open, show }: Props): JSX.Element => (
  show
    ? <Tooltip title="Remove box from the shipment">
      <IconButton onClick={ open } color="primary">
        <WorkOff />
      </IconButton>
    </Tooltip>
    : <></>
);
